import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { CustomerState } from '../store/customer/types';

export interface UseFeaturesResult {
    loading: boolean;
    call: boolean;
    vri: boolean;
    directory: boolean;
    switchDevice: boolean;
}

export default function useFeatures(): UseFeaturesResult {
    const { features, fetchingFeatures, activeCustomerNumber } = useSelector<
        RootState,
        CustomerState
    >((state) => state.customerDetail);

    const getCallFeature = () => {
        if (
            fetchingFeatures ||
            activeCustomerNumber?.numberTypeId === 'extn' ||
            activeCustomerNumber?.numberTypeId === 'vri'
        ) {
            return false;
        }

        return !!features?.call;
    };

    const getVRIFeature = () => {
        if (fetchingFeatures || activeCustomerNumber?.numberTypeId === 'extn') {
            return false;
        }

        return !!features?.twiliovri;
    };

    const getDirectoryFeature = () => {
        if (fetchingFeatures || activeCustomerNumber?.numberTypeId === 'vri') {
            return false;
        }

        return !!features?.directory;
    };

    const switchDevice = !fetchingFeatures && !!features?.switchDevice;

    const call = getCallFeature();
    const vri = getVRIFeature();
    const directory = getDirectoryFeature();

    return { loading: fetchingFeatures, call, vri, directory, switchDevice };
}
